'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeHome = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx(jsxRuntime.Fragment, {
            children: jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.8518 3.44245C12.6016 3.25258 12.2556 3.25258 12.0054 3.44245L4.57686 9.08031C4.40247 9.21267 4.30005 9.41899 4.30005 9.63791V18.4347C4.30005 19.6716 5.2863 20.6997 6.5333 20.6997H11.7288V14.2971H13.1288V20.6997H18.3239C19.5709 20.6997 20.5572 19.6716 20.5572 18.4347V9.63791C20.5572 9.41899 20.4547 9.21267 20.2804 9.08031L12.8518 3.44245Z",
                fill: "currentColor"
            })
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.4286 4L5 9.63786V12.9558V18.4347C5 19.2986 5.6864 19.9996 6.53325 19.9996H12.4286H18.3239C19.1707 19.9996 19.8571 19.2986 19.8571 18.4347V12.9558V9.63786L12.4286 4Z",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M12.4287 14.2971V20",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

module.exports = LargeHome;
